/**
 * Fallback mappings for discovery configuration tab labels
 *
 * This object provides fallback text for tab labels when localization keys
 * cannot be resolved. It maps localization keys to their English fallback text.
 *
 * The localization system works as follows:
 * 1. First, try to get translated text using the localization key
 * 2. If translation fails, use the fallback text from this mapping
 * 3. If no fallback exists, display the key itself
 *
 * @constant {Record<string, string>}
 *
 * @example
 * // Usage in component:
 * const label = formatMessage(
 *   'AOB.ServiceNow.discovery.CONNECTION_SETTINGS.title',
 *   DISCOVERY_CONFIG_TAB_LABEL_FALLBACK_MAPPINGS['AOB.ServiceNow.discovery.CONNECTION_SETTINGS.title']
 * );
 * // Result: "Connection Settings" (either translated or fallback)
 */
const DISCOVERY_CONFIG_TAB_LABEL_FALLBACK_MAPPINGS: Record<string, string> = {
  // Connection settings tab - for configuring database connections, credentials, etc.
  'AOB.ServiceNow.discovery.CONNECTION_SETTINGS.title': 'Connection Settings',

  // CI Classes tab - for selecting which Configuration Items to discover
  // Note: The '***' indicates this is likely a placeholder or development label
  'AOB.ServiceNow.discovery.CI_CLASSES.title': 'CI Classes***',

  // Attribute mapping tab - for mapping fields between source and target systems
  'AOB.ServiceNow.discovery.ATTRIBUTE_MAPPING.title': 'Attribute Mapping',

  // Scheduling tab - for configuring when discovery jobs should run
  'AOB.ServiceNow.discovery.SCHEDULE.title': 'Scheduling',
};

export default DISCOVERY_CONFIG_TAB_LABEL_FALLBACK_MAPPINGS;
